module.exports = __webpack_public_path__ + "img/smart-m-3.c428d2c2.jpg";